exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".social-media-group-popup .field-box.social-campaign-detail-field>div[data-v-50c58e0e],.social-media-group-popup .field-box.social-series-detail-field>div[data-v-50c58e0e]{margin-top:16px}.campaign-details[data-v-50c58e0e]{padding-top:0}.type-label[data-v-50c58e0e]{color:var(--primary);display:block;font-weight:600;font-size:1em;text-transform:uppercase}h1[data-v-50c58e0e]{font-size:22px}h1.edit-d-title[data-v-50c58e0e]:after{color:var(--hover-grey);background:transparent}textarea.title-field[data-v-50c58e0e]{font-size:22px}", ""]);

// exports
